import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table
} from "reactstrap";

import Timestamp from "shared/react_components/Timestamp";

const PhrasesSpokenModal = ({ isOpen, toggle, phrasesSpoken }) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalHeader>Phrases Spoken</ModalHeader>
    <ModalBody>
      <p>The following words and/or phrases were spoken on this call.</p>
      <Table>
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Speaker</th>
            <th>Words Spoken</th>
          </tr>
        </thead>
        <tbody>
          {phrasesSpoken.map(({ timestamp, speaker, wordsSpoken }) => (
            <tr key={timestamp}>
              <td><Timestamp seconds={timestamp} /></td>
              <td>{speaker}</td>
              <td>{wordsSpoken}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={toggle}>
        Close
      </Button>
    </ModalFooter>
  </Modal>
);

PhrasesSpokenModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  phrasesSpoken: PropTypes.arrayOf(
    PropTypes.shape({
      timestamp: PropTypes.number.isRequired,
      speaker: PropTypes.string.isRequired,
      wordsSpoken: PropTypes.string.isRequired
    })
  ).isRequired
};

export default PhrasesSpokenModal;
